module.exports = __webpack_public_path__ + "img/hr-red-asterisk-15.981d059d.png";